import { Component } from '@angular/core';
import { ImpersonateService } from 'src/app/service/impersonate.service';

@Component({
  selector: 'flow-impersonate',
  templateUrl: './impersonate.component.html',
  styleUrls: ['./impersonate.component.scss']
})
export class ImpersonateComponent {

  public sortByCol = 'first_name';

  constructor(
    public service : ImpersonateService
  ) { }

  selectedEmployee : string = '';

  select() {
    if(this.selectedEmployee != '' ) {
      let employee = this.service.employees.find((e) => e['email'] == this.selectedEmployee) || null;
      this.service.$selected.next(employee);
    }
    else {
      this.service.$selected.next(null);
    }
  }

  reset() {
    this.selectedEmployee = '';
    this.service.$selected.next(null);
  }

}
